import { render, staticRenderFns } from "./SortArray.vue?vue&type=template&id=c14ae1c0"
import script from "./SortArray.vue?vue&type=script&lang=js"
export * from "./SortArray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports